'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { tonalGradient } from '../system/tone';
import styles from './MediaHeader.module.css';
export function MediaHeader({ src, tone = 'navy', height = 132, bg, inset = 'md', topLeft, topRight, bottomLeft, bottomRight, muted = false, scrim = false, }) {
    const [errored, setErrored] = useState(false);
    const edge = `var(--space-${inset})`;
    // Reset error state when src changes so a new url gets a fresh load attempt.
    useEffect(() => {
        setErrored(false);
    }, [src]);
    // The image is a real <img> (not a CSS background) so the browser can
    // lazy-load and async-decode covers in long card grids. It layers on top
    // of the tone gradient; a broken / 404'd URL falls back to the gradient.
    const gradient = tonalGradient(tone);
    const showImage = src !== undefined && !errored;
    // Split the background into its own absolutely-positioned layer so the
    // `muted` filter cascades onto it alone — corner slots stay sharp. CSS
    // filters on a parent unconditionally affect every descendant, so the
    // background can't be a parent here.
    return (_jsxs("div", { className: styles.header, style: {
            '--media-header-h': `${height}px`,
            flexShrink: 0,
            position: 'relative',
            overflow: 'hidden',
        }, children: [_jsxs("div", { "aria-hidden": true, style: {
                    position: 'absolute',
                    inset: 0,
                    ...(muted ? { filter: 'grayscale(0.85)', opacity: 0.6 } : {}),
                }, children: [_jsx("div", { style: { position: 'absolute', inset: 0, background: bg ?? gradient } }), showImage && (_jsx("img", { src: src, alt: "", loading: "lazy", decoding: "async", draggable: false, onError: () => setErrored(true), style: {
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        } }))] }), scrim && (_jsx("div", { "aria-hidden": true, style: {
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.55), transparent 66%)',
                } })), topLeft && _jsx("div", { style: { position: 'absolute', top: edge, left: edge }, children: topLeft }), topRight && _jsx("div", { style: { position: 'absolute', top: edge, right: edge }, children: topRight }), bottomLeft && _jsx("div", { style: { position: 'absolute', bottom: edge, left: edge }, children: bottomLeft }), bottomRight && _jsx("div", { style: { position: 'absolute', bottom: edge, right: edge }, children: bottomRight })] }));
}
//# sourceMappingURL=MediaHeader.js.map